export default "<i *ngIf=\"componentConfig && componentConfig.imgSrc\" class=\"fal fa-images cursor-pointer\" (click)=\"previewImg()\"></i>\r\n";